/* global localStorage */
// Tiny per-device key/value store: localStorage on web, AsyncStorage on native.
let AS = null;
try { AS = require('@react-native-async-storage/async-storage').default; } catch { /* web */ }

export const kv = {
  async get(key) {
    try { if (typeof localStorage !== 'undefined') return localStorage.getItem(key); } catch { /* ignore */ }
    try { if (AS) return await AS.getItem(key); } catch { /* ignore */ }
    return null;
  },
  async set(key, value) {
    try { if (typeof localStorage !== 'undefined') { localStorage.setItem(key, value); return; } } catch { /* ignore */ }
    try { if (AS) await AS.setItem(key, value); } catch { /* ignore */ }
  },
};
